<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-card-account-mail" :title="'Teklifler'" :desc="'Teklif talepleri listesi'" />
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="secilenMesajlar"
          :items="mesajListesi"
          :page.sync="tableParams.page"
          :items-per-page="list.limit"
          :headers="iletisimTable.headers"
          :no-data-text="iletisimTable.noDataText"
          calculate-widths
          hide-default-footer
          class="elevation-1 mb-3"
          @page-count="tableParams.pageCount = $event"
          :loading="tableParams.listStatus"
          :loading-text="iletisimTable.loadingText"
          :server-items-length="mesajSayisi"
        >
          <template v-slot:[`item.name`]="{ item }">
            <v-icon size="20" class="mr-2">mdi-account-circle</v-icon>
            <span class="font-weight-medium">{{ item.name }}</span>
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <v-icon size="20" class="mr-1">mdi-email-variant</v-icon>
            {{ item.email }}
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <v-icon size="20" class="mr-1">mdi-calendar-range</v-icon>
            {{ dateFormat(item.date) }}
          </template>
          <template v-slot:[`item.code`]="{ item }">
            <v-btn small depressed class="mr-2" @click="mesajGoruntule(item.code)">
              <v-icon size="20" class="mr-1">mdi-email-search</v-icon>
              {{ $t("ILETISIM.SHOW_MESSAGE_BTN") }}
            </v-btn>
            <v-btn small depressed @click="mesajKaldirDialog(item.code)">
              <v-icon size="20" class="mr-1">mdi-delete-outline</v-icon>
              {{ $t("ILETISIM.DELETE_MESSAGE_BTN") }}
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination v-model="pagination.page" :length="tableParams.pageCount" circle
                      @input="pageClick"></v-pagination>
      </v-col>
    </v-row>
    <v-dialog v-model="mesajGoruntuleData.dialog" max-width="1000">
      <v-card>
        <v-card-title class="text-subtitle-1 black--text">
          <v-icon left color="black">mdi-email-variant</v-icon>
          {{ $t("ILETISIM.MESSAGE_DETAIL_DIALOG.TITLE") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4 text-subtitle-2 font-weight-regular black--text">
          <div class="contact-content mb-4">
            <v-icon size="20">mdi-minus</v-icon>
            <span class="contact-conten-text" v-if="mesajGoruntuleData.dialog"
                  v-html="parseIt(mesajGoruntuleData.data.desc)"></span>
          </div>
          <div v-if="mesajGoruntuleData.data.fields" class="grey--text text--darken-2 mb-3">
            <strong>İlgili Hizmetler:</strong>
            <span v-if="!mesajGoruntuleData.data.fields.length" class="font-weight-bold ml-2">-</span>
            <br>
            <span class="text-caption" :key="sKey" v-for="(service, sKey) in mesajGoruntuleData.data.fields">
            {{ service }}
              <span v-if="mesajGoruntuleData.data.fields.length - 1 !== sKey">,</span>
          </span>
          </div>
          <div class="grey--text text--darken-2">
            <v-chip small label class="font-weight-medium mr-2">
              <v-icon size="14" class="mr-1">mdi-account-circle</v-icon>
              {{ mesajGoruntuleData.data.name }}
            </v-chip>
            <v-chip small label class="font-weight-medium mr-2">
              <v-icon size="14" class="mr-1">mdi-email</v-icon>
              {{ mesajGoruntuleData.data.email }}
            </v-chip>
            <v-chip v-show="mesajGoruntuleData.data.gsm" small label class="font-weight-medium mr-2">
              <v-icon size="14" class="mr-1">mdi-phone</v-icon>
              {{ mesajGoruntuleData.data.gsm }}
            </v-chip>
            <v-chip v-show="mesajGoruntuleData.data.company" small label class="font-weight-medium mr-2">
              <v-icon size="14" class="mr-1">mdi-domain</v-icon>
              {{ mesajGoruntuleData.data.company }}
            </v-chip>
            <v-chip v-show="mesajGoruntuleData.data.company" :href="mesajGoruntuleData.data.website" target="_blank" small label class="font-weight-medium mr-2">
              <v-icon size="14" class="mr-1">mdi-link-variant</v-icon>
              {{ mesajGoruntuleData.data.website }}
            </v-chip>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-4" text @click="mesajGoruntuleData.dialog = false">
            <v-icon size="20" class="mr-1">mdi-close</v-icon>
            {{ $t("ILETISIM.MESSAGE_DETAIL_DIALOG.CLOSE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mesajKaldirData.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("ILETISIM.MESSAGE_DELETE_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("ILETISIM.MESSAGE_DELETE_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="mesajKaldirData.dialog = false">
            {{ $t("ILETISIM.MESSAGE_DELETE_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="mesajKaldirData.loading" @click="mesajKaldir()">
            {{ $t("ILETISIM.MESSAGE_DELETE_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import IletisimService from "@/services/IletisimService";
import PanelTitle from "../../../components/PanelTitle.vue";

export default {
  components: { PanelTitle },
  name: "TeklifMesajları",
  data() {
    return {
      iletisimTable: {
        headers: [
          { text: this.$t("ILETISIM.LIST.TABLE_FIELDS.NAME_SURNAME"), value: "name", sortable: false, width: 370 },
          { text: "Şirket Adı", value: "company", sortable: false, width: 370 },
          { text: this.$t("ILETISIM.LIST.TABLE_FIELDS.EMAIL"), value: "email", sortable: false },
          { text: this.$t("ILETISIM.LIST.TABLE_FIELDS.DATE"), value: "date", sortable: false },
          { text: this.$t("ILETISIM.LIST.TABLE_FIELDS.ACTIONS"), value: "code", sortable: false }
        ],
        noDataText: this.$t("ILETISIM.NO_MESSAGES_FOUND"),
        loadingText: this.$t("ILETISIM.LOADING_MESSAGES")
      },
      secilenMesajlar: [],
      pagination: {
        page: 1,
        lastPage: 0
      },
      tableParams: {
        page: 1,
        pageCount: 0,
        listStatus: true
      },
      list: {
        start: 0,
        limit: 12
      },
      listStatus: true,
      mesajListesi: [],
      mesajSayisi: 0,
      mesajKaldirData: {
        dialog: false,
        code: 0,
        loading: false
      },
      mesajGoruntuleData: {
        dialog: false,
        data: {}
      }
    };
  },
  methods: {
    getFreeQuoteList() {
      const { start, limit } = this.list;
      this.tableParams.listStatus = true;
      IletisimService.freeQuoteList({ start, limit })
        .then(res => {
          if (res.status === 200) {
            this.mesajListesi = res.data.list;
            this.mesajSayisi = res.data.count;
          }
        })
        .then(() => {
          this.tableParams.listStatus = false;
        });
    },
    mesajKaldir() {
      const mesajCode = this.mesajKaldirData.code;
      this.mesajKaldirData.loading = true;
      IletisimService.mesajKaldir(mesajCode).then(res => {
        if (res.status === 200) {
          this.getFreeQuoteList();
          this.mesajKaldirData.loading = false;
          this.$snotify.success(this.$t("ILETISIM.NOTIFY.MESSAGE_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.mesajKaldirData.dialog = false;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    mesajKaldirDialog(mesajCode) {
      this.mesajKaldirData.code = mesajCode;
      this.mesajKaldirData.dialog = true;
    },
    mesajGoruntule(mesajCode) {
      this.mesajGoruntuleData.data = this.mesajListesi.filter(m => m.code === mesajCode)[0];
      this.mesajGoruntuleData.dialog = true;
    },
    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.list.start = this.pagination.page * this.list.limit - this.list.limit;

        this.getFreeQuoteList();
      }
    },
    dateFormat(date) {
      return new Intl.DateTimeFormat(this.$store.state.Language.apiLanguage, {
        dateStyle: "long",
        timeStyle: "short"
      }).format(new Date(date));
    },
    parseIt(value) {
      return value.split("\n").join("<br>");
    }
  },
  created() {
    this.getFreeQuoteList();
  },
  watch: {
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    }
  }
};
</script>

<style></style>
